import React from 'react';
import { Switch, Route } from "wouter";

import Home from './pages/00_indexPage/index';
import About from './pages/01_aboutPage/01_aboutPage'

import HearingTest from './pages/02_utilityPages/01_hearingTestPage/01_hearingTestPage'

import HearingAidsProducts from './pages/02_utilityPages/04_hearingAidProductsPage/04_hearingAidProductsPage'
import HearingSolution from './pages/02_utilityPages/02_HearingSolution/02_HearingSolution'
import HearingLoss from './pages/02_utilityPages/03_SignsOfHearingLossPage/03_SignsOfHearingLossPage'

import Contact from './pages/05_contactPage/05_contactPage'
import Appointment from './pages/06_appointmentPage/06_appointmentPage'


function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/our-process" component={HearingTest} />
      <Route path="/hearing-aids-products" component={HearingAidsProducts} />
      <Route path="/hearing-solutions" component={HearingSolution} />
      <Route path="/signs-of-hearing-loss" component={HearingLoss} />
      <Route path="/contact" component={Contact} />
      <Route path="/appointment" component={Appointment} />
    </Switch>
  );
}

function App() {
  return (
      <Router />
  );
}

export default App;